{
  "lastUpdatedAt": "2026-07-02T12:28:00.628Z",
  "lastFetchAttemptAt": "2026-07-02T12:28:00.628Z",
  "organization": null,
  "parseError": null,
  "fetchError": null
}